interface Params {
  orderItem: Pick<App.OrderItem, 'package' | 'packagePrice' | 'channelMarkupId' | 'reservation' | 'total'>
  duration: number
  checkIn?: string
  checkOut?: string
  packageUniqueKey?: string
  isLpc: boolean
  isDerbysoftDateChange?: boolean
  price: number
  memberPrice: number
  useMemberPrice: boolean
  surcharge: number
}

/** The new accommodation total for a date change, before subtracting the original total. */
export default function getHotelDateChangePrice({
  orderItem,
  duration,
  checkIn,
  checkOut,
  packageUniqueKey,
  isLpc,
  isDerbysoftDateChange = false,
  price,
  memberPrice,
  useMemberPrice,
  surcharge,
}: Params): number {
  const newPackageSelected = orderItem.package.duration !== duration ||
    (packageUniqueKey !== undefined && orderItem.package.uniqueKey !== packageUniqueKey)

  if (!newPackageSelected && checkIn && checkOut &&
    checkIn === orderItem.reservation?.startDate && checkOut === orderItem.reservation?.endDate) {
    return orderItem.total
  }

  // Supplier cancel/rebook retains the purchased base for the same Flash package.
  const repricePackage = newPackageSelected || isLpc
  const priceToUse = repricePackage || (orderItem.channelMarkupId && !isDerbysoftDateChange) ? price : orderItem.packagePrice
  const memberPriceToUse = repricePackage ? memberPrice : orderItem.packagePrice
  const nextPrice = useMemberPrice && memberPriceToUse > 0 ? memberPriceToUse : priceToUse

  return nextPrice + surcharge
}
